/* angular */
import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from "@angular/http";
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule, UrlSerializer } from '@angular/router';
import { FormsModule } from '@angular/forms';

/* solar */
import { SolPaginationModule, ChipModule } from "@solar/components";
import { Newsflash } from '@solar-web/newsflash/bundle';

/* ngx translate */
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

/* celine base */
import { CelineAppModule } from '@api/base-app.module';

/* ngrx */
import { ActionReducer, Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

/* store, actions & effects */
import { reducers } from './store/store';
import { Effects } from './store/effects/effects';
import { ThresholdUserEffects } from './store/effects/user.effects';
import * as ui from '@api/store/actions/ui.actions';
import * as thresholdActions from './store/actions/actions';

/* threshold */
import { ThresholdComponentsModule, AppComponent } from './components/index';
import { ThresholdServicesModule, RouterConnectedService, AuthenticationConnectedService, UserProfileService } from './services';
import { SearchThresholdService } from './services/search-threshold.service';
import { SearchResultsListComponent } from './components/search/search-results-list.component';
import { SearchCategoryFilterComponent } from './components/search/search-category-filter.component';
import { SearchCategoryCheckboxComponent } from './components/search/search-category-checkbox.component';
import { TranslateLoaderThreshold } from './services/translate-loader-threshold.service';
import { FeatureToggleService } from './services/feature-toggle.service';
import { IDToken } from './models/id-token';
import { CustomUrlSerializer } from './services/custom-url-serializer.service';
import { ReportToInstanaErrorHandler } from './services/reportToInstana.errorHandler';
import { ScriptService } from './services/script.service';
import { QRCodeModule } from 'angularx-qrcode';

// oidc-client
import { UserManager } from 'oidc-client';
import { FeatureFlagService } from './services/feature-flag.service';
import { UserPreferencesService } from './services/user-preferences.service';

declare var window: any;
type CreateReducer = (asyncReducers: any) => ActionReducer<any>;

const DEFAULT_LANG = 'en-mz';


@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		RouterModule,
		CelineAppModule,
		HttpModule,
		HttpClientModule,
		ThresholdServicesModule,
		ThresholdComponentsModule,
		RouterModule.forRoot(
			RouterConnectedService.initialRoutes(), {
			useHash: true
		}
		),
		StoreModule,
		EffectsModule.run(Effects),
		EffectsModule.run(ThresholdUserEffects),
		SolPaginationModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: (httpClient: HttpClient, store: Store<any>) => new TranslateLoaderThreshold(httpClient, store),
				deps: [HttpClient, Store]
			},
			isolate: false
		}),
		QRCodeModule
	],
	declarations: [
		SearchResultsListComponent,
		SearchCategoryFilterComponent,
		SearchCategoryCheckboxComponent
	],
	exports: [
		SearchResultsListComponent
	],
	providers: [
		SearchThresholdService,
		TranslateLoaderThreshold,
		AuthenticationConnectedService,
		FeatureToggleService,
		FeatureFlagService,
		UserPreferencesService,
		ScriptService,
		{ provide: UrlSerializer, useClass: CustomUrlSerializer },
		{ provide: ErrorHandler, useClass: ReportToInstanaErrorHandler },
	],
	entryComponents: [
		AppComponent
	],
	bootstrap: [
		AppComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class ThresholdAppModule {

	// oidc client
	private oidcClient: UserManager;

	/**
	 *
	 * @param featureToggleService
	 * @param authenticationService
	 * @param store
	 */
	constructor (
		private featureToggleService: FeatureToggleService,
		private authenticationService: AuthenticationConnectedService,
		private store: Store<any>) {

		// merge ngrx store
		let newReducer = window.createReducer(reducers);
		this.store.replaceReducer(newReducer);

		// set current theme
		// this.setTheme();

		// grab global instance of oidc client
		this.oidcClient = window._oidc;

		// feature toggle service for localization
		if (this.featureToggleService.isEnabled('localization')) {

			// add supported languages
			let supportedLanguages = process.env.config.feature.localization.supported_languages;
			this.store.dispatch(new thresholdActions.SetLocalizationSupportedLangsAction(supportedLanguages));

			if (this.oidcClient) {
				this.oidcClient.getUser().then((user) => {
					if (user) {
						try {
							let idToken: IDToken = this.authenticationService.parseJwt(user.id_token);
							this.store.dispatch(new thresholdActions.SetLocalizationDefaultLangAction(idToken.locale))

							// set theme to 'nbc' to test 'nbc' functionality
							// this.setTheme();
						}
						catch (e) {
							// error parsing
							console.log((<Error>e).message);//conversion to Error type
							this.store.dispatch(new thresholdActions.SetLocalizationDefaultLangAction(DEFAULT_LANG))
						}
					}
				});
			} else {
				// default language
				this.store.dispatch(new thresholdActions.SetLocalizationDefaultLangAction(DEFAULT_LANG))
			}
		}
	}

	// setup initial theme in redux to be in sync with imported theme css
	private setTheme() {
		// theme can be 'nbc' or theme
		const theme: string = process.env.config.theme;
		this.store.dispatch(new ui.GotoThemeAction(theme));
	}

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/app.module.ts